import React from 'react'
import { brandColors, gradientClasses, getBrandGradient } from '../theme/brandColors'

/**
 * Demo component showcasing the HoneyGrid brand colors and gradients
 */
export const BrandDemo: React.FC = () => {
	return (
		<div className="p-8 space-y-8">
			<h1 className="text-4xl font-bold mb-8">HoneyGrid Brand Colors</h1>
			
			{/* Primary Brand Colors */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Primary Brand Colors</h2>
				<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
					<div className="space-y-2">
						<div 
							className="h-24 rounded-lg shadow-md"
							style={{ backgroundColor: brandColors.primary }}
						/>
						<p className="text-sm font-medium">Primary</p>
						<p className="text-xs text-muted-foreground">{brandColors.primary}</p>
					</div>
					<div className="space-y-2">
						<div 
							className="h-24 rounded-lg shadow-md border"
							style={{ backgroundColor: brandColors.primaryContrast }}
						/>
						<p className="text-sm font-medium">Primary Contrast</p>
						<p className="text-xs text-muted-foreground">{brandColors.primaryContrast}</p>
					</div>
				</div>
			</section>
			
			{/* Application Colors */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Application Colors</h2>
				<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
					<div className="space-y-2">
						<div 
							className="h-24 rounded-lg shadow-md"
							style={{ backgroundColor: brandColors.primaryAction }}
						/>
						<p className="text-sm font-medium">Primary Action</p>
						<p className="text-xs text-muted-foreground">{brandColors.primaryAction}</p>
					</div>
					<div className="space-y-2">
						<div 
							className="h-24 rounded-lg shadow-md"
							style={{ backgroundColor: brandColors.primaryLight }}
						/>
						<p className="text-sm font-medium">Primary Light</p>
						<p className="text-xs text-muted-foreground">{brandColors.primaryLight}</p>
					</div>
					<div className="space-y-2">
						<div 
							className="h-24 rounded-lg shadow-md"
							style={{ backgroundColor: brandColors.hexGrid }}
						/>
						<p className="text-sm font-medium">Hex Grid</p>
						<p className="text-xs text-muted-foreground">{brandColors.hexGrid}</p>
					</div>
				</div>
			</section>
			
			{/* Brand Gradient */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Brand Gradient</h2>
				<div className="space-y-4">
					<div className={`h-32 rounded-lg shadow-md ${gradientClasses.gradient}`} />
					<p className="text-sm text-muted-foreground">Main brand gradient</p>
				</div>
			</section>
			
			{/* Gradient Variations */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Gradient Variations</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div className="space-y-2">
						<div className={`h-32 rounded-lg shadow-md ${gradientClasses.radial}`} />
						<p className="text-sm font-medium">Radial Gradient</p>
					</div>
					<div className="space-y-2">
						<div className={`h-32 rounded-lg shadow-md ${gradientClasses.animated}`} />
						<p className="text-sm font-medium">Animated Gradient</p>
					</div>
				</div>
			</section>
			
			{/* Gradient Effects */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Gradient Effects</h2>
				<div className="space-y-4">
					<div className={`p-6 rounded-lg shadow-md ${gradientClasses.overlay}`}>
						<h3 className="text-lg font-semibold mb-2">Gradient Overlay</h3>
						<p className="text-sm text-muted-foreground">
							Cards and surfaces can use a subtle gradient overlay
						</p>
					</div>
					<div className="p-6 rounded-lg">
						<h3 className={`text-3xl font-bold mb-2 ${gradientClasses.text}`}>
							Gradient Text Effect
						</h3>
						<p className="text-sm text-muted-foreground">
							Text can use the brand gradient for special emphasis
						</p>
					</div>
					<div className={`p-6 ${gradientClasses.border}`}>
						<h3 className="text-lg font-semibold mb-2">Gradient Border</h3>
						<p className="text-sm text-muted-foreground">
							Elements can have a gradient border effect
						</p>
					</div>
				</div>
			</section>
			
			{/* Usage with inline styles */}
			<section>
				<h2 className="text-2xl font-semibold mb-4">Dynamic Gradient Usage</h2>
				<div className="space-y-4">
					<div 
						className="h-32 rounded-lg shadow-md"
						style={{ background: getBrandGradient(45) }}
					/>
					<p className="text-sm text-muted-foreground">
						Gradient with custom angle (45deg)
					</p>
				</div>
			</section>
		</div>
	)
}
